@if (!isLoading && showUpdateMappingConfig) {
  <lib-form-field-container
    [title]="'SCIM Mapping Configuration'"
    [label]="'OPTIONAL'"
    [helpText]="'Configure how the fields from your identities are mapped to Ziti identities.'"
    [showHeader]="showHeader"
    >
    <span class="form-field-label" style="padding-top: 10px; padding-bottom:10px">These properties dictate how fields from your Users map to Ziti Identities</span>
    <div class="form-field-container form-field-row" id="UpdateScimMappingConfig">
      <div class="form-field-label-container" style="gap: var(--paddingMedium)">
        <div class="form-field-header">
          <div class="form-field-title-container">
            <span class="form-field-title">Identity Name</span>
            <div
              class="form-field-info infoicon"
              matTooltip="The field from the SCIM Identity to map to the Ziti Identity"
              matTooltipPosition="above"
            ></div>
          </div>
        </div>
        <select
          [(ngModel)]="valueMappings.get('name').valueFactory.propertyName"
          id="identityNameMapping"
          class="form-field-dropdown"
          >
          <option value="">Select an Identity Name Mapping</option>
          @for (nameMapping of identityNameMappings; track nameMapping) {
            <option
              [value]="nameMapping['value']"
              >
              {{ nameMapping['display'] }}
            </option>
          }
        </select>
      </div>
      <div class="form-field-label-container" style="gap: var(--paddingMedium)">
        <div class="form-field-header">
          <div class="form-field-title-container">
            <span class="form-field-title">Auth Policy</span>
            <div
              class="form-field-info infoicon"
              matTooltip="The Auth Policy to use for Identities created via this Integration"
              matTooltipPosition="above"
            ></div>
          </div>
        </div>
        <select
          [(ngModel)]="valueMappings.get('authPolicyId').valueFactory.staticValue"
          id="authPolicyId"
          class="form-field-dropdown"
          >
          <option value="">Select an Authentication Policy</option>
          @for (policy of authPolicies; track policy) {
            <option
              [value]="policy.id"
              >
              {{ policy.name }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="form-field-label-container" style="gap: var(--paddingMedium)">
      <div class="form-field-header">
        <div class="form-field-title-container">
          <span class="form-field-title">External ID</span>
          <div
            class="form-field-info infoicon"
            matTooltip="The field from the SCIM User to map to the External ID."
            matTooltipPosition="above"
          ></div>
        </div>
        <span class="form-field-label">{{mappingConfigErrMap['externalIdNotJsonPath'] ? 'INVALID JSONPath' : 'OPTIONAL'}}</span>
      </div>
      <mat-radio-group class="scim-external-id-radio-group" [(ngModel)]="externalIdSelection" style="justify-content: space-evenly;">
        <mat-radio-button
          [disableRipple]="true"
          [value]="NONE"
          >
          None
        </mat-radio-button>
        <mat-radio-button
          [disableRipple]="true"
          [value]="USER_NAME"
          >
          User Name
        </mat-radio-button>
        <mat-radio-button
          [disableRipple]="true"
          [value]="PRIMARY_EMAIL"
          >
          Primary Email
        </mat-radio-button>
        <div>
          <mat-radio-button
            [disableRipple]="true"
            [value]="OTHER"
            >
            <div style="display:flex">
              <span>Custom Mapping</span>
              <!-- TODO - Add back in comment about viewing the documentation to learn more on how to format this field when the docs are ready-->
              <div class="form-field-info infoicon"
                matTooltip="If the userName or primary email is not suitable, provide a JsonPath to the property on your users to use for the externalId."
                matTooltipPosition="above">
              </div>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
      @if (externalIdSelection == 'other') {
        <input class="form-field-input" placeholder="$.emails[?(@.primary == true)].value" [ngClass]="{ error: mappingConfigErrMap['propertyName'] || mappingConfigErrMap['externalId'] }" [(ngModel)]="customExternalIdMapping.valueFactory.propertyName"/>
      }
    </div>
    @if (showApply) {
      <div class="row buttonRow right">
        @if (!processingMappingConfig) {
          <button (click)="applyMappingConfig()" class="save">
            Apply
          </button>
        }
        @if (processingMappingConfig) {
          <button class="save confirm" disabled>Saving <span class="spinner"></span></button>
        }
      </div>
    }
  </lib-form-field-container>
}